import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {Component, ElementRef, ViewChild, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {MatAutocompleteSelectedEvent, MatAutocomplete} from '@angular/material/autocomplete';
import {MatChipInputEvent} from '@angular/material/chips';
import { debounceTime, tap, switchMap, map, catchError, startWith } from 'rxjs/operators';
import { Observable, of , BehaviorSubject} from 'rxjs';
import { DatasourcesService } from '@app/services/datasources.service';
import { Item } from '@app/models/item.inferface';

@Component({
  selector: 'app-partner-chips',
  templateUrl: './partner-chips.component.html',
  styleUrls: ['./partner-chips.component.scss'],
})
export class PartnerChipsComponent implements OnInit {

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  clientAutoComplete$: Observable<any[]> = null;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  chipCtrl: FormControl;
  filteredselectedItems: Observable<string[]>;
  selectedItems: Item[] = [];

  labelString: string = "";

  isLoading = new BehaviorSubject<boolean>(false);

  @Input() initialItems;
  @Input() permission: boolean;
  @Input() context: string;
  @Input() label: string;
  @Input() chipControlFormRequired: boolean;
  chipControlFormError: boolean = false;
  @Input() permissionRemove;
  @Input() assistantInputHs;

  @Output() selectedItemsChange = new EventEmitter<any[]>();
  @Output() newAssistantDataSource = new EventEmitter<any>();
  @Output() delAssistantDataSource = new EventEmitter<any>();
  @ViewChild('groupInput', { static: true }) groupInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto', { static: true }) matAutocomplete: MatAutocomplete;

  /**
     * Constructor
     *
     * @param {FuseTranslationLoaderService} _fuseTranslationLoaderService
     */
  constructor(
    private dataSourceService: DatasourcesService
    ) {
  }

  ngOnInit() {
    if(this.label && typeof this.label == 'string'){this.labelString = this.label}
    
    if(this.chipControlFormRequired)
    {this.chipCtrl = new FormControl('', Validators.required);}
    else{this.chipCtrl = new FormControl();}

    // Selected items for the constructor
    if(this.initialItems){
      this.selectedItems = this.initialItems;
    }

    this.setObservable();
  }

  private setObservable() {
    this.clientAutoComplete$ = this.chipCtrl.valueChanges.pipe(
      startWith(''),
      // delay emits
      debounceTime(300),
      // use switch map so as to cancel previous subscribed events, before creating new once
      switchMap(value => {
        if (value !== '') {
          this.isLoading.next(true);
          // lookup from github
          return this.search(value);
        } else {
          // if no value is pressent, return null
          return of(null);
        }
      }),
      tap(() => this.isLoading.next(false))
    );
    // this.clientAutoComplete$.subscribe(() => this.isLoading.next(false));
  }

  colabLostFocus(){
    if(this.chipControlFormRequired){
        if(this.selectedItems && this.selectedItems.length > 0){
          this.chipControlFormError = false;
        }
        if(!this.selectedItems || this.selectedItems.length < 1){
            this.chipControlFormError = true;
        }
      }
  }

  search(value: any): Observable<any[]> {
    return this.dataSourceService.getThirdPartiesManaged(value.toLowerCase()).pipe(
      // map the item property of the github results as our return object
      map(results => {
        return results;
      }),
      // catch errors
      catchError(_ => {
        return of(null);
      })
    );
  }

  add(event: MatChipInputEvent): void {
    if (this.matAutocomplete && this.matAutocomplete.isOpen) {
      return;
    }

    const input = event.input;
    const rawValue = (event.value || '').trim();
    let itemsAdded = [];
    
    if (rawValue) {
      rawValue
        .split(',')              // separa por coma
        .map(v => v.trim())       // quita espacios
        .filter(v => v.length)    // ignora vacíos
        .forEach(name => {
          const newItem: Item = { description: name } as Item;
          itemsAdded.push(newItem);
          this.newAssistantDataSource.emit(newItem);
        });

      itemsAdded.forEach(item => {
        this.isLoading.next(true);
        // console.log(item)}
        this.dataSourceService.getThirdPartiesManaged(item.description.toLowerCase()).subscribe(
          res => {
            let itemFound = res[0];
            if(itemFound?.id){
              this.selectedItems.push(itemFound);
              this.isLoading.next(false);
              this.selectedItemsChange.emit(this.selectedItems);
            }
          },
          err => {
            console.log(err);
            this.isLoading.next(false);
          }
        )
      });
    }
  
    if (input) input.value = '';
    this.chipCtrl.setValue('');
  }

  remove(item, indx: number): void {
    this.delAssistantDataSource.emit(item);
    this.selectedItems.splice(indx, 1);
    this.selectedItemsChange.emit(this.selectedItems);
    if(this.chipControlFormRequired){
      if(this.selectedItems && this.selectedItems.length > 0){
        this.chipControlFormError = false;
      }
      if(!this.selectedItems || this.selectedItems.length < 1){
          this.chipControlFormError = true;
      }
    }
  }

  canRemove(assistant) {
    if(this.permissionRemove != null && this.permissionRemove != undefined){
      this.removable = this.permissionRemove;
      if(this.assistantInputHs &&
        this.assistantInputHs != null &&
        this.assistantInputHs != undefined){
          this.assistantInputHs.forEach(item => {
            if(item === assistant.partnerApprovalId){
                this.removable = false;
            }
          });
      }
      return this.removable;
    }
    return false;
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    let newAssistant: Item = {
      id: event.option.value.id,
      description: event.option.value.description
    }
    if (!this.selectedItems.some(x => x.id == newAssistant.id)) this.selectedItems.push(newAssistant);
    
    this.groupInput.nativeElement.value = '';
    this.chipCtrl.setValue(null);

    this.clientAutoComplete$ = null;
    this.setObservable();
    this.newAssistantDataSource.emit(newAssistant);
    this.selectedItemsChange.emit(this.selectedItems);
  }

  canAddColab(){
    if(this.context == "create"){
      return true;
    }
    if(this.permission != null && this.permission != undefined){
      if((this.permission && this.context=="edit")){
        return true;
      }
    }
    return false;
  }

}
